import type { Schemas } from '#shopware'
import { getCategoryRoute } from '@shopware/helpers'

/**
 * Whether the category is the current route or one of its ancestors.
 * Matches whole path segments, so `/marken/adidas` does not match `/marken/adidas-golf`.
 * Uses `includes` instead of `startsWith` because the route may carry a locale prefix (`/en/...`).
 */
export function isCategoryRouteActive(routePath: string, category: Schemas['Category']): boolean {
    const categoryRoute = getCategoryRoute(category)
    const categoryPath = (typeof categoryRoute === 'string' ? categoryRoute : categoryRoute.path)?.replace(/\/$/, '')
    if (!categoryPath) return false

    return `${routePath}/`.includes(`${categoryPath}/`)
}
